module.exports = __webpack_public_path__ + "static/media/OLIVE-USDT.63b85dec.png";